import React, { useEffect, useState } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { useParams, useHistory, withRouter } from 'react-router-dom';
import moment from 'moment';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { getCrq } from 'AppSrc/core/crq/crq-queries';
import { generateFormDataFromCrq } from 'AppSrc/core/crq/crq-form-utils';
import { VIEW_CRQ } from 'AppSrc/core/components/router/routes';
import {
  currentSelectedNetwork,
  getIsOlaCrq,
  getIsInternationalCrq,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { getViewCrqPowers } from 'AppSrc/core/components/view-crq-screen/utility-functions/get-view-crq-powers';
import {
  saveEditFormDataThunk,
  saveSectionDataForEditFormThunk,
} from 'AppSrc/core/actions/actions-edit-form';
import {
  getEditingStatus,
} from 'AppSrc/core/components/forms/form-section-utility-functions';
import {
  updateEditCrqWithId,
  addAdditionalApproversFromViewCrq,
} from 'AppSrc/core/actions/actions-update-edit-form';
import { flAddApproverGroupsToCrq } from 'AppSrc/core/crq/crq-list-actions';
import { SubmitCreateCrqProgress } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/submit-create-crq-progress';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createCrqSectionComponents } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/components';
import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import { getHeaderText } from 'AppSrc/core/components/forms/form-utility-functions';
import { getCurrentSectionOrder } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-order';
import { getFailedToSubmitAlertData } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/section-change-request-utils';
import {
  VIEWING_CRQ,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { crqWorkItemsFetched } from 'AppSrc/core/work-info-items/work-info-item-actions';
import { BackAndRefresh } from '../utility/back-refresh';
import { holidaysList } from '../forms/form-types/create-crq/section-three/section-three-data-layer-functions';
import { FIXED, FIXEDOLO, MOBILE } from '../forms/value-dependency-constants';



// FN: 20/05/2020
// At the time of writing this there was nothing that would ever change the editingStatus for this view
const editingStatus = getEditingStatus({
  // There is no back button on edit crq
  isNavEditing: false,
  // We always get to this view via the summary page
  isSummaryEditing: true,
  flow: VIEWING_CRQ,
});

const formDataFromServerShape = PropTypes.shape({
  formSectionsByDisplayOrder: PropTypes.array,
  dataByFormSectionId: PropTypes.object,
  status: PropTypes.string,
  coordinatorName: PropTypes.string,
  peerReviewerName: PropTypes.string,
  requesterName: PropTypes.string,
});


const getViewCrqPath = (network, crqId) => VIEW_CRQ.getPath({ network, crqId });

const getSectionIndex = ({
  userRoles,
  network,
  sectionId,
  formData,
}) => {
  const changeDetails = 'CHANGE_DETAILS';
  const isOloByService = formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)';
  const isOloCrq = getIsOlaCrq(formData) || isOloByService;
  const isIcmCrq = getIsInternationalCrq(formData);
  const sectionOrder = getCurrentSectionOrder({
    network,
    userRoles,
    isOloCrq,
    isIcmCrq,
  });
  return sectionOrder ? sectionOrder.indexOf(sectionId) : null;
};



class EditCrqScreenDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.handleSuccessfulSubmit = this.handleSuccessfulSubmit.bind(this);
    this.getInfoItem = this.getInfoItem.bind(this);
  }

  componentDidMount() {
    const {
      formData,
    } = this.props;
    const setHolidayDate = () => {
      if (formData) {
        const currentNetwork = formData.dataByFormSectionId.CHANGE_TYPE.dataByFieldId.select_network.displayValues[0].value || '';
        if (currentNetwork === FIXED || currentNetwork === MOBILE || currentNetwork === FIXEDOLO) {
          moment.updateLocale('en', {
            holidays: holidaysList,
            holidayFormat: 'MM-DD-YYYY',
          });
        }
      }
    };
    setTimeout(setHolidayDate, 1000);
  }

  getInfoItem() {
    const isInfoItem = window.localStorage.getItem('isInfoItem');
    if (isInfoItem === 'true') {
      window.localStorage.setItem('isInfoItem', true);
    }
    else {
      window.localStorage.setItem('isInfoItem', false);
    }
  }

  handleSuccessfulSubmit(sectionData) {
    const {
      updateSectionData,
      crqId,
      formData,
    } = this.props;
    updateSectionData(crqId, sectionData, formData);
  }


  render() {
    const {
      crqId,
      network,
      fetching,
      formData,
      userRoles,
      // remedyIds, // turned off for lint but do need for future ticket
      sectionId,
      history,
    } = this.props;

    const showLoader = fetching || !formData;


    if (showLoader) {
      return (
        <LoadingSpinner />
      );
    }

    const SectionComponent = createCrqSectionComponents[sectionId];

    if (!SectionComponent) {
      return (
        <h1>
          {`Cannot find section for ${sectionId}.`}
        </h1>
      );
    }


    const formType = CREATE_CRQ;

    const headerText = getHeaderText({
      formType,
      selectedNetwork: network,
      crqId,
    });

    const sectionIndex = getSectionIndex({
      userRoles,
      network,
      sectionId,
      formData,
    });

    const navigationProps = {
      prev: null,
      cancel: () => {
        history.push(getViewCrqPath(network, crqId));
        this.getInfoItem();
      },
      next: null,
      saveChanges: true,
      submitForm: null,
    };

    const failedToSubmitAlertData = getFailedToSubmitAlertData(crqId);

    return (
      <div className="main-form-container page-content-container">

        <div className="form-top page-top">
          <h1 className="page-title">
            {headerText}
          </h1>
          <BackAndRefresh />
        </div>

        <div className="main-form page-content">

          <div className="form-fields page-content-inner">
            <SectionComponent
              handleSuccessfulSubmit={this.handleSuccessfulSubmit}
              formData={formData}
              // FN: 03/04/2020
              // this will hopefully never fire, but if it does, it's nice to know why a sudden bug appeared...
              // The fix will most likey be to give it this.handleSuccssfulSubmit; It's basically a hang up of
              // the view being used both here and in main-form
              navigateToSection={() => console.warn('navigateToSection was called but we have no function for it!')}
              userRoles={userRoles}
              // FN: 16/04/2020: I believe submitFormToEndpoint was only ever called from clicking the next button.
              // If I was wrong, please remove the console.warn and replace it with the commented out code!
              submitFormToEndpoint={() => console.warn('submitFormToEndpoint was called. Please implement it!')} // {this.handleSuccessfulSubmit}
              navigationProps={navigationProps}
              editingStatus={editingStatus}
              sectionIndex={sectionIndex}
            />
          </div>
        </div>
        <SubmitCreateCrqProgress
          editCrqId={crqId}
          // custon alert data for if the submit fails
          errorAlertData={failedToSubmitAlertData}
        />
      </div>
    );
  }
}


EditCrqScreenDisplay.propTypes = {
  network: PropTypes.string,
  crqId: PropTypes.string,
  fetching: PropTypes.bool,
  userRoles: PropTypes.objectOf(PropTypes.string),
  // remedyIds: PropTypes.objectOf(PropTypes.string), // turned off for lint but will need in future ticket
  formData: formDataFromServerShape,
  updateSectionData: PropTypes.func,
  sectionId: PropTypes.string,
  history: ReactRouterPropTypes.history,
};

const EditCrqScreenUnconnected = ({
  userRoles,
  remedyIds,
  updateSectionData,
  saveDataToRedux,
  formData,
  status,
  isChangeAnalyst, // mapping changeAnalyst to the props of EditCrqScreenUnconnected method
}) => {
  const { crqId, network, sectionId } = useParams();
  const history = useHistory();
  const [fetching, setFetching] = useState(false);
  // load up crq data on mount
  useEffect(() => {
    const remedyId = remedyIds[network];
    setFetching(true);
    getCrq(network, crqId).then(
      (response) => {
        const { crq, workInfoItems } = response;

        const crqFormData = generateFormDataFromCrq({
          crq,
          workInfoItems,
          userRoles,
        });

        const {
          canEditForm,
        } = getViewCrqPowers({
          remedyId,
          formData: crqFormData,
          isChangeAnalyst, // Sending isChangeAnalyst as an extra field to the getViewCrqPowers
          userRoles,
          sectionId, // passing sectionId to getViewCrqPowers to validate the logic based on sectionId.
        });

        // if the user is not allowed to edit the form, redirect to unauthorised
        if (!canEditForm) {
          history.push('/unauthorised');
          return;
        }
        saveDataToRedux({
          crqId,
          crqFormData,
          workInfoItems,
        });
        setFetching(false);
      },
    ).catch((error) => {
      console.error(error);
      // redirect to the page not found screen
      history.push('/notfound');
    });
  }, [crqId, network, userRoles, remedyIds, saveDataToRedux, setFetching, history, isChangeAnalyst, sectionId]);
  // Sending isChangeAnalyst as an extra field for the React Hooks check
  // Added sectionID to the dependency for React Hooks.

  return (
    <EditCrqScreenDisplay
      network={network}
      userRoles={userRoles}
      sectionId={sectionId}
      remedyIds={remedyIds}
      crqId={crqId}
      fetching={fetching}
      formData={formData}
      updateSectionData={updateSectionData}
      history={history}
      status={status}
    />
  );
};

EditCrqScreenUnconnected.propTypes = {
  remedyIds: PropTypes.objectOf(PropTypes.string),
  userRoles: PropTypes.objectOf(PropTypes.string),
  saveDataToRedux: PropTypes.func,
  status: PropTypes.string,
  formData: formDataFromServerShape,
  updateSectionData: PropTypes.func,
  isChangeAnalyst: PropTypes.bool, // changeAnalyst PropTypes validation
};

const mapStateToProps = (state, ownProps) => {
  const crqId = ownProps.match.params.crqId;
  return ({
    remedyIds: state.auth.user.remedyIds,
    userRoles: state.auth.user.roles,
    formData: state.editForm.formDataById[crqId],
    isChangeAnalyst: state && state.auth.isChangeAnalyst, // Fetching if the user is changeAnalyst or not
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  saveDataToRedux: ({
    crqId,
    crqFormData,
    // formData,
    workInfoItems,
  }) => {
    // we don't need to run the validator here as the data is only displayed on the summary page
    const validateFormData = false;
    // save the work info item data
    dispatch(crqWorkItemsFetched(crqId, workInfoItems));
    // as this is dispatch from an asynch request, we need to return it to catch any errors
    return dispatch(saveEditFormDataThunk(crqId, crqFormData, validateFormData, editingStatus));
  },
  // sending formDatas here to resolve already declared in upper scope error.
  updateSectionData: (crqId, sectionData, formDatas) => {
    const {
      // crqId,
      // status,
      history,
      // isChangeAnalyst,
    } = ownProps;
    dispatch(saveSectionDataForEditFormThunk({ crqId, sectionData, editingStatus }));
    const networkCopy = formDatas.network;
    // Calling this api on stage 5 followed by process approver action api.
    if (networkCopy === 'fixed' && formDatas.status === '5') {
      dispatch(addAdditionalApproversFromViewCrq(crqId))
        .then(() => {
          // const {
          //   history,
          // } = ownProps;
          // const {
          //   formData,
          // } = afterSubmitParams;

          // const network = currentSelectedNetwork(formData);

          dispatch(flAddApproverGroupsToCrq(networkCopy, crqId));

          const viewPath = getViewCrqPath(networkCopy, crqId);

          history.push(viewPath);
        });
    }
    else {
      dispatch(updateEditCrqWithId(crqId))
        .then((afterSubmitParams) => {
          // const {
          //   history,
          // } = ownProps;
          const {
            formData,
          } = afterSubmitParams;

          const network = currentSelectedNetwork(formData);

          const viewPath = getViewCrqPath(network, crqId);

          history.push(viewPath);
        });
    }
  },
});

const EditCrqScreen = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditCrqScreenUnconnected));

export {
  EditCrqScreen,
  EditCrqScreenDisplay,
};
